import { pb } from './pocketbase';

export const getFilesByFolderId = async (folderId) => {
    try {
        const records = await pb.collection('folder_documents').getFullList({
            filter: `folder_id = "${folderId}"`,
            expand: 'folder_id',
            sort: '-created'
        });
        return records;
    } catch (error) {
        if (error.status === 404) {
            return [];
        }
        throw error;
    }
};

export const uploadDocumentToFolder = async (folderId, file, partnerId, title, type) => {
    try {
        const formData = new FormData();
        formData.append('folder_id', folderId);
        formData.append('partner_id', partnerId);
        formData.append('title', title);
        formData.append('type', type);
        formData.append('file', file);

        const record = await pb.collection('folder_documents').create(formData);
        return record;
    } catch (error) {
        console.error('Erreur lors de l\'upload du document:', error);
        throw error;
    }
};

export const deleteDocument = async (documentId) => {
    try {
        await pb.collection('folder_documents').delete(documentId);
        return true;
    } catch (error) {
        console.error('Erreur lors de la suppression du document:', error);
        throw error;
    }
};

export const downloadDocument = async (document) => {
    try {
        const url = pb.files.getUrl(document, document.file);
        const link = window.document.createElement('a');
        link.href = url;
        link.download = document.file;
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
    } catch (error) {
        console.error('Erreur lors du téléchargement:', error);
        throw error;
    }
};
